// Merkt die beim Registrieren gewählte E-Mail-Präferenz (Checkbox "Mails erhalten"),
// da /auth/register keine Session öffnet und Settings daher erst beim ersten
// erfolgreichen Login (nach Email-Bestätigung) angewendet werden können.
import { userApi } from '../api';

const STORAGE_KEY = 'pendingEmailOptIn';

export const setPendingEmailOptIn = (username, emailNotifications) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ username, emailNotifications }));
  } catch (e) { /* localStorage nicht verfügbar */ }
};

/**
 * Wendet eine für diesen Username hinterlegte E-Mail-Präferenz an, sobald eine
 * Session existiert (nach Login). Löscht den Eintrag danach, egal ob erfolgreich.
 */
export const applyPendingEmailOptIn = async (username) => {
  let pending;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return;
    pending = JSON.parse(raw);
  } catch (e) {
    return;
  }
  if (!pending || pending.username?.toLowerCase() !== username?.toLowerCase()) return;

  try {
    const settingsResult = await userApi.getSettings();
    const current = settingsResult.success && settingsResult.data ? settingsResult.data : {};
    await userApi.updateSettings({
      ...current,
      email_notifications: pending.emailNotifications,
      new_release_alerts: pending.emailNotifications ? true : current.new_release_alerts,
    });
  } catch (e) {
    // Best-effort: Settings können später manuell angepasst werden
  } finally {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) { /* noop */ }
  }
};
